// https://upmostly.com/tutorials/modal-components-react-custom-hooks

import React from "react";
import ReactDOM from "react-dom";
import "@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css";
import "./styles.scss";

const Modal = ({ isShowing, hide, image, name, position }) =>
  isShowing
    ? ReactDOM.createPortal(
        <div>
          <div className="modal-overlay" />
          <div
            className="modal-wrapper"
            aria-modal
            aria-hidden
            tabIndex={-1}
            role="dialog"
            onClick={hide}
          >
            <div className="ui modal">
              <div className="modal-header">
                <button
                  type="button"
                  className="modal-close-button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={hide}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              {name && (
                <p>
                  {name}, {position}
                </p>
              )}
              <div className="image content">
                <img className="image" width="100%" src={image} />
                <i className="expand arrows alternate icon" />
              </div>
            </div>
          </div>
        </div>,
        document.body
      )
    : null;

export default Modal;
